module.exports = __webpack_public_path__ + "img/hilight-2.d0357180.png";